/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Amjad Ali',
        title: "CTO UConnect",
        text: "Working with Salman was a game-changer for our business. His development skills and attention to detail resulted in a flawless website that has exceeded our expectations.",
        image: boy2
    },
    {
        id: 2,
        name: 'Monica Geller',
        title: 'Software Engr at Betterhelp',
        text: "I've had the pleasure of collaborating with Salman on multiple projects, and I am always impressed by their technical expertise and innovative solutions.",
        image: girl2
    },
    {
        id: 3,
        name: 'Adila Naaqvi',
        title: 'Discretelogix Pvt. Ltd.',
        text: "Thanks to Salman, our website is now faster, more user-friendly, and generates more leads. Their dedication to delivering high-quality work is unmatched. :)",
        image: girl1
    },
    {
        id: 4,
        name: 'Adnan Khan',
        title: 'Design Bytes International',
        text: "As a developer, Salman is a true professional. They communicate clearly, meet deadlines, and consistently deliver outstanding results.",
        image: boy1
    },
    {
        id: 5,
        name: 'Zia Karim',
        title: 'Google Developers Student Club',
        text: "If you're looking for a talented developer who can take your website to the next level, look no further than Salman. They are a true expert in their field.",
        image: boy3
    },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

